import {
  PushHistoryStackEntryAction,
  createPushHistoryStackEntryActionCreator,
} from '../history-stack';
import { ADMIN_PANELS_HISTORY_ACTION_TYPE_PREFIX } from './constants';
import { AdminPanelName } from '../../state';
import { AdminPanelsActionType } from './admin-panels-action-type';

export type PushAdminPanel = PushHistoryStackEntryAction<
  AdminPanelsActionType.Push
>;

export const pushAdminPanel = createPushHistoryStackEntryActionCreator<
  AdminPanelsActionType.Push,
  AdminPanelName,
  any
>(ADMIN_PANELS_HISTORY_ACTION_TYPE_PREFIX);
